export default __webpack_public_path__ + "static/media/logo.726cf780.png";